module.exports = __webpack_public_path__ + "img/word-logo.df6565f6.svg";